import {
    instance as axios,
    setJwtToken,
    setMultiPartHeader,
} from "../../config/axiosInstance";
// ---------------------Product-listing--------------------------
export const productListApi = async (data) => {
    const endPoint =
        `product/list` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};

// ------------------------Add Product------------------
export const addProductApi = async (data) => {
    const endPoint = `product/create`;
    return await axios.post(endPoint, data, setMultiPartHeader());
};
// ------------------------Edit Product------------------
export const editProductApi = async (data) => {
    const endPoint = `product/update`;
    return await axios.put(endPoint, data, setMultiPartHeader());
};
export const updateProducttStatus = async (data) => {
    const endPoint = `product/change_status`;
    return await axios.put(endPoint, data, setJwtToken());
};
// ------------------------- remove Status------------
export const removeProductApi = async (id) => {
    const endPoint = `product/delete/${id}`;
    return await axios.delete(endPoint, setJwtToken());
};
// ------------------------- event detail------------
export const productDetailApi = async (id) => {
    const endPoint = `product/detail/${id}`;
    return await axios.get(endPoint, setJwtToken());
};


// Web Product 
export const webProductListApi = async (data) => {
    const endPoint =
        `product/scrape_product` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
export const refreshScrapeListApi = async (data) => {
    const endPoint =
        `product/refresh_scrape_product` +
        "?" +
        new URLSearchParams({ ...data }).toString();

    return await axios.get(endPoint, setJwtToken());
};
export const addScrapeProductApi = async (data) => {
    const endPoint = `product/add_scrape_product`;
    return await axios.post(endPoint, data, setJwtToken());
};
export const deleteScrapeProductApi = async (data) => {
    const endPoint = `product/delete_scrape_product`;
    return await axios.post(endPoint, data, setJwtToken());
};








